<div class="similar-inquiries-md-inquiry-head">
  <!-- Clamped to two lines rather than one, so baseTruncate's width check would never fire here:
       the tooltip carries the full name unconditionally. -->
  <div
    class="main-qualification-text similar-inquiries-md-inquiry-qualification"
    [ngbTooltip]="inquiry.data.mainQualification?.name"
    container="body"
  >
    {{ inquiry.data.mainQualification?.name }}
  </div>

  <div
    class="similar-inquiries-md-inquiry-period"
    baseTruncate
  >
    {{ inquiry.data.dateFrom | baseFormatDate }} – {{ inquiry.data.dateTo | baseFormatDate }}
  </div>

  <div class="similar-inquiries-md-inquiry-author">
    <div baseTruncate>
      {{ 'inquiry.by' | translate }} {{ inquiry.data.createdBy?.firstName }} {{ inquiry.data.createdBy?.lastName }}
    </div>
    <div baseTruncate>{{ 'inquiry.at' | translate }} {{ inquiry.data.createdAt | baseFormatDate: true }}</div>
  </div>

  <div class="similar-inquiries-md-inquiry-columns">
    <div
      class="similar-inquiries-md-inquiry-column"
      *ngFor="let column of columns; trackBy: trackByColumn"
      [class.text-primary]="inquiry.availableShifts[column.shift]"
      [class.text-light-gray]="!inquiry.availableShifts[column.shift]"
    >
      <span
        *ngIf="column.shift === shiftTypes.flex"
        class="text-uppercase"
      >
        {{ column.labelKey | translate }}
      </span>
      <i
        *ngIf="column.icon"
        class="fa-regular fa-fw {{ column.icon }}"
      ></i>
    </div>
  </div>
</div>

<div
  class="similar-inquiries-md-inquiry-body"
  #scrollBody
  (scroll)="onBodyScroll()"
>
  <div class="similar-inquiries-md-inquiry-grid">
    <ng-container *ngFor="let date of inquiry.dates; let rowIndex = index; trackBy: trackByDate">
      <div
        class="similar-inquiries-md-inquiry-cell"
        *ngFor="let bubble of date.bubbles; let columnIndex = index; trackBy: trackByBubble"
        [class.similar-inquiries-md-inquiry-weekend]="date.isWeekend"
        [style.grid-row]="rowIndex + 1"
        [style.grid-column]="columnIndex + 1"
      >
        <base-customer-shift-plan-bubble
          [bubble]="bubble"
          [isCalendar]="false"
        ></base-customer-shift-plan-bubble>
      </div>
    </ng-container>
  </div>
</div>
